import Http from '../../../common/services/Http';
import CustomFile from 'common/models/CustomFile';
import { BulkContractFile, BulkContractsCommitResult, BulkContractsPreviewResult, BulkContractsRequest } from './models/BulkContractsModels';

// Task #66347: atualização/inserção em massa de contratos a partir da grelha estilo Excel.
class BulkContractsService {

    // Valida as linhas e diz, por linha, se vai criar ou atualizar. Não escreve nada.
    public preview(model: BulkContractsRequest) {
        return Http.post<BulkContractsPreviewResult>('bulkContracts/preview', model);
    }

    public commit(model: BulkContractsRequest) {
        return Http.post<BulkContractsCommitResult>('bulkContracts/commit', model);
    }

    // Carrega o ficheiro e devolve a referência a guardar na célula. O mesmo id pode depois ficar em
    // várias linhas — é uma referência, não uma cópia.
    public uploadFile(file: File) {
        return Http.postWithFile<BulkContractFile>('bulkContracts/upload', {}, [file as CustomFile]);
    }
}

export default new BulkContractsService();
